var exports = {
  "kL": "xdde3148b--8abf7e--container",
  "_8": "xdde3148b--8abf7e--img",
  "Qs": "xdde3148b--8abf7e--content",
  "Kk": "xdde3148b--8abf7e--icon",
  "BI": "xdde3148b--8abf7e--icon-desktop",
  "bQ": "xdde3148b--8abf7e--text-desktop",
};

module.exports = exports;
